
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from '@/contexts/AuthContext';

export const useJobList = () => {
  const { session } = useAuth();

  return useQuery({
    queryKey: ["jobs-list", session?.user?.id],
    queryFn: async () => {
      if (!session?.user?.id) {
        console.log('No authenticated user, returning empty jobs list');
        return [];
      }

      console.log('Fetching jobs list for user:', session.user.id);

      // Query with explicit user_id filter for strict user isolation
      const { data, error } = await supabase
        .from("jobs")
        .select(`
          *,
          jobs_clients!left (
            clients (
              id,
              name
            )
          )
        `)
        .eq('user_id', session.user.id) // Explicit user filtering
        .is('deleted_at', null) // Only get non-deleted jobs
        .order("created_at", { ascending: false });
      
      if (error) {
        console.error('Error fetching jobs list:', error);
        throw error;
      }
      
      // Transform the data to include client_name
      const transformedData = data?.map(job => ({
        ...job,
        client_name: job.jobs_clients?.[0]?.clients?.name || null
      })) || [];

      console.log('Successfully fetched jobs list:', transformedData.length);
      return transformedData;
    },
    enabled: !!session?.user?.id,
  });
};
